var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFourOclock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 17.063A8.062 8.062 0 1 0 9 .938a8.062 8.062 0 0 0 0 16.125m0-1.125A6.937 6.937 0 1 1 9 2.063a6.937 6.937 0 0 1 0 13.875M9 4.2a.75.75 0 0 1 .75.75v3.586l2.285 1.143a.75.75 0 1 1-.67 1.342l-2.7-1.35A.75.75 0 0 1 8.25 9V4.95A.75.75 0 0 1 9 4.2",
  clipRule: "evenodd"
})));
export default SvgFourOclock;